import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'New Construction Wiring', href: '/services/new-construction' },
  { label: 'Residential Service & Repair', href: '/services/residential-repair' },
  { label: 'Generators', href: '/services/generators' },
  { label: 'Electric Car Chargers', href: '/services/ev-chargers' },
  { label: 'Solar & Panel Upgrades', href: '/services/solar-panel' },
  { label: 'Specialty Lighting', href: '/services/specialty-lighting' },
];

const Footer = () => (
  <footer className="relative bg-[#060E1C] pt-20 pb-10 overflow-hidden">
    {/* Top glow line */}
    <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/20 to-transparent" />

    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 pb-14 border-b border-white/5">

        {/* Column 1 — Brand */}
        <div>
          <img
            src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/a10a21fb6a7818eb13553848461bbd4a.png"
            alt="DOC Electric LLC"
            className="h-24 w-auto object-contain mb-4"
          />
          <p className="text-[#5A7A96] text-[13px] leading-relaxed mb-5">
            Faith-based, employee-owned electrical excellence serving Kalamazoo and southwest Michigan for over 20 years.
          </p>
          <div className="flex items-center gap-3">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#1E3048] hover:border-[#00D9FF]/40 text-[#3A566E] hover:text-[#00D9FF] transition-all duration-300 cursor-pointer">
              <i className="ri-facebook-fill text-[15px]" />
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#1E3048] hover:border-[#00D9FF]/40 text-[#3A566E] hover:text-[#00D9FF] transition-all duration-300 cursor-pointer">
              <i className="ri-instagram-fill text-[15px]" />
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#1E3048] hover:border-[#00D9FF]/40 text-[#3A566E] hover:text-[#00D9FF] transition-all duration-300 cursor-pointer">
              <i className="ri-linkedin-fill text-[15px]" />
            </a>
          </div>
        </div>

        {/* Column 2 — Services */}
        <div>
          <h4 className="text-white text-[12px] font-bold uppercase tracking-[2px] mb-5">Services</h4>
          <ul className="flex flex-col gap-3">
            {serviceLinks.map((s) => (
              <li key={s.label}>
                <Link to={s.href} className="text-[#5A7A96] text-[13px] hover:text-[#00D9FF] transition-colors duration-200 flex items-center gap-2 group cursor-pointer">
                  <span className="w-1 h-1 rounded-full bg-[#00D9FF]/0 group-hover:bg-[#00D9FF] transition-colors duration-200 flex-shrink-0" />
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3 — Company */}
        <div>
          <h4 className="text-white text-[12px] font-bold uppercase tracking-[2px] mb-5">Company</h4>
          <ul className="flex flex-col gap-3">
            {[
              { label: 'About Us', href: '/about', internal: true },
              { label: 'Why Choose Us', href: '/about', internal: true },
              { label: 'Our Specialties', href: '/#specialties', internal: false },
              { label: 'Reviews', href: '/reviews', internal: true },
              { label: 'Contact', href: '/contact', internal: true },
            ].map((l) => (
              <li key={l.label}>
                {l.internal ? (
                  <Link to={l.href} className="text-[#5A7A96] text-[13px] hover:text-[#00D9FF] transition-colors duration-200 flex items-center gap-2 group cursor-pointer">
                    <span className="w-1 h-1 rounded-full bg-[#00D9FF]/0 group-hover:bg-[#00D9FF] transition-colors duration-200 flex-shrink-0" />
                    {l.label}
                  </Link>
                ) : (
                  <a href={l.href} className="text-[#5A7A96] text-[13px] hover:text-[#00D9FF] transition-colors duration-200 flex items-center gap-2 group cursor-pointer">
                    <span className="w-1 h-1 rounded-full bg-[#00D9FF]/0 group-hover:bg-[#00D9FF] transition-colors duration-200 flex-shrink-0" />
                    {l.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Column 4 — Contact */}
        <div>
          <h4 className="text-white text-[12px] font-bold uppercase tracking-[2px] mb-5">Get In Touch</h4>
          <div className="flex flex-col gap-4">
            <a href="tel:+12693700765" className="flex items-start gap-3 group cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#00D9FF]/10 flex-shrink-0 mt-0.5">
                <i className="ri-phone-fill text-[#00D9FF] text-sm" />
              </span>
              <div>
                <div className="text-white font-bold text-[16px] group-hover:text-[#00D9FF] transition-colors duration-200">(269) 370-0765</div>
                <div className="text-[#5A7A96] text-[12px]">Call or text anytime</div>
              </div>
            </a>
            <div className="flex items-start gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#00D9FF]/10 flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-2-fill text-[#00D9FF] text-sm" />
              </span>
              <div>
                <div className="text-white font-semibold text-[14px]">Kalamazoo, MI</div>
                <div className="text-[#5A7A96] text-[12px]">Serving SW Michigan</div>
              </div>
            </div>
            <a href="/#contact" className="inline-flex items-center justify-center gap-2 mt-1 px-5 py-2.5 bg-[#00D9FF] hover:bg-[#00c5e8] text-[#0A1628] font-bold text-[12px] uppercase tracking-wider rounded-lg transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,217,255,0.35)] cursor-pointer whitespace-nowrap">
              Request Free Estimate
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-[#4A6888] text-[12px]">
          &copy; 2025 DOC Electric LLC. All rights reserved. Licensed Electrical Contractor — Michigan.
        </p>
        <div className="flex items-center gap-4">
          <a href="#" className="text-[#4A6888] hover:text-[#5A7A96] text-[12px] transition-colors duration-200 cursor-pointer">Privacy Policy</a>
          <span className="text-[#1E3048]">|</span>
          <a href="#" className="text-[#4A6888] hover:text-[#5A7A96] text-[12px] transition-colors duration-200 cursor-pointer">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
